module.exports = __webpack_public_path__ + "static/img/share_img4.06626b45.png";